import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import {IconConfig} from './config/icon.config';
import {ComponentConfig} from './config/component.config';
import {AppConfig} from './config/app.config';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/free-solid-svg-icons';
import '@fortawesome/free-regular-svg-icons';
import '@fortawesome/vue-fontawesome';

import '@sweetalert2/theme-bootstrap-4/bootstrap-4.min.css'

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../public/css/custom.scss';

import 'vue-multiselect/dist/vue-multiselect.min.css'

import 'popper.js'
import $ from 'jquery'

import __ from 'lodash';

Vue.config.productionTip = false;

global.$ = $
global.__ = __

IconConfig.config();
ComponentConfig.pluginComponents();
ComponentConfig.baseComponent();

AppConfig.appConfig();
AppConfig.appProgressBar();
AppConfig.appSweetAlert2();
AppConfig.elementFocus();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
